/**
 * Initialize section-specific modules.
 *
 * Recommended pattern:
 * - one file per section in src/js/sections/
 * - import and call here, guarding with DOM presence inside each module
 *
 * Example:
 *   import { initExampleSection } from './example-section.js';
 *   export function initSectionModules(root = document) {
 *     initExampleSection(root);
 *   }
 *
 * The contact-form.js module is included as a ready-to-use starter:
 * it handles CF7 + phone mask + WhatsApp redirect after successful submission.
 * Activate it by adding data-contact-form and data-whatsapp-number attributes
 * to the section container in your section partial.
 *
 * @param {Document} root
 */
import { initContactForm } from './contact-form.js';
import { initTreatmentsCarousel } from './treatments-carousel.js';
import { initQuemSomosGallery } from './quem-somos-gallery.js';
import { initClickableArrows } from './clickable-arrows.js';
import { initClickAudioVideos } from './click-audio-video.js';

export function initSectionModules(root = document) {
  initContactForm(root);
  initTreatmentsCarousel(root);
  initQuemSomosGallery(root);
  initClickableArrows(root);
  initClickAudioVideos(root);
}
